<template>
  <router-view />
</template>
<script>
export default {
  name: "Accesos",
};
</script>

<style scoped></style>
